import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/home'
import Login from '@/views/Login'
import { getToken } from '@/utils/user'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    }
  ]
})

router.beforeEach((to, from, next) => {
  /* 登录页面或者含有 token 的都不需要登录*/
  if (to.name === 'login' || getToken()) {
    next(true)
  } else {
    next({ name: 'login', replace: true })
  }
})

export default router
